const printButton = document.querySelector( '.summary-pdf-button-wrap' );

if ( printButton ) {
	setTimeout( () => {
		printButton.classList.remove( 'loading' );
	}, 3000 );
}
